export enum AssignmentStatus {
    ASSIGNMENT_STATUS_AWAITING_EMPLOYEE_ACCEPT = 'afventer-medarbejder-accept',
    ASSIGNMENT_STATUS_AWAITING_EXECUTION = 'afventer-medarbejder-udfyldelse',
    ASSIGNMENT_STATUS_GEM = 'adhoc',
    ASSIGNMENT_STATUS_AWAITING_ACCEPT = 'afventer-godkendelse',
    ASSIGNMENT_STATUTS_SALES_CONSULTANT = 'i-udbud-fra-kunde'
}